var PropertyEventType = {
  AUCTION: {
    name: 'AUCTION'
  },
  TENDER: {
    name: 'TENDER'
  },
  PLACE_HOLDER: {
    name: 'PLACE_HOLDER'
  },
  EXHIBITION: {
    name: 'EXHIBITION'
  },
  OPEN_HOURS: {
    name: 'OPEN_HOURS'
  }
};
export default PropertyEventType;